// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteSettingsForm-space1-l7lrj {
	margin-bottom: 6px !important;
}

.SiteSettingsForm-space2-SErba {
	margin-bottom: 12px !important;
}

.SiteSettingsForm-space3-Sgngn {
	margin-bottom: 18px !important;
}

.SiteSettingsForm-space4-SQxDK {
	margin-bottom: 24px !important;
}

.SiteSettingsForm-space5-sPE26 {
	margin-bottom: 30px !important;
}

.SiteSettingsForm-space6-xJ6sy {
	margin-bottom: 36px !important;
}

.SiteSettingsForm-space7-KlQLC {
	margin-bottom: 42px !important;
}

.SiteSettingsForm-space8-HGq8Q {
	margin-bottom: 48px !important;
}

.SiteSettingsForm-spaceTop1-kay2T {
	margin-top: 6px !important;
}

.SiteSettingsForm-spaceTop2-MgvpP {
	margin-top: 12px !important;
}

.SiteSettingsForm-spaceTop3-UI0tD {
	margin-top: 18px !important;
}

.SiteSettingsForm-spaceTop4-qcaGS {
	margin-top: 24px !important;
}

.SiteSettingsForm-spaceTop5-uoUhv {
	margin-top: 30px !important;
}

.SiteSettingsForm-spaceTop6-hl3Oh {
	margin-top: 36px !important;
}

.SiteSettingsForm-spaceTop7-CsADB {
	margin-top: 42px !important;
}

.SiteSettingsForm-spaceTop8-qhvOG {
	margin-top: 48px !important;
}

.SiteSettingsForm-noMargin-y4xL2 {
	margin: 0px !important;
}

.SiteSettingsForm-padding1-tzQsr {
	padding-bottom: 6px !important;
}

.SiteSettingsForm-padding2-gcDKE {
	padding-bottom: 12px !important;
}

.SiteSettingsForm-padding3-Ryylr {
	padding-bottom: 18px !important;
}

.SiteSettingsForm-padding4-lUrgp {
	padding-bottom: 24px !important;
}

.SiteSettingsForm-padding5-ADyuB {
	padding-bottom: 30px !important;
}

.SiteSettingsForm-padding6-BYeX1 {
	padding-bottom: 36px !important;
}

.SiteSettingsForm-padding7-MGU1S {
	padding-bottom: 42px !important;
}

.SiteSettingsForm-paddingTop1-d6ZTm {
	padding-top: 6px !important;
}

.SiteSettingsForm-paddingTop2-segOG {
	padding-top: 12px !important;
}

.SiteSettingsForm-paddingTop3-JWQWW {
	padding-top: 18px !important;
}

.SiteSettingsForm-paddingTop4-7CiJi {
	padding-top: 24px !important;
}

.SiteSettingsForm-paddingTop5-vTf4v {
	padding-top: 30px !important;
}

.SiteSettingsForm-paddingTop6-OI3ht {
	padding-top: 36px !important;
}

.SiteSettingsForm-paddingTop7-PRqLt {
	padding-top: 42px !important;
}

.SiteSettingsForm-noPadding-qZgFL {
	padding: 0px !important;
}

.SiteSettingsForm-spaceMarginBottom0-Tot8w {
	margin-bottom: 0;
}

.SiteSettingsForm-textBold-BWJGU {
	font-weight: 500 !important;
}

.SiteSettingsForm-textBolder-wxMu7 {
	font-weight: 700 !important;
}

.SiteSettingsForm-textNormal-z8Pln {
	font-weight: normal !important;
}

/*New Design Text Colors */

.SiteSettingsForm-textDarkBlue-HBfvP {
	color: rgb(20, 39, 94) !important;
}

.SiteSettingsForm-textLightBlue-Io8vQ {
	color: rgb(57, 87, 106) !important;
}

.SiteSettingsForm-textLightSandleGreen-mnBh2 {
	color: rgb(76, 86, 41) !important;
}

.SiteSettingsForm-textLightBrown-PAZIk {
	color: rgb(115, 79, 33) !important;
}

.SiteSettingsForm-textMediumMaroon-A6ImB {
	color: rgb(87, 37, 51) !important;
}

.SiteSettingsForm-textBrown-Pmysh {
	color: rgb(160, 47, 24) !important;
}

.SiteSettingsForm-textMaroon-tbNOg {
	color: rgb(155, 49, 67) !important;
}

.SiteSettingsForm-textDarkBrown-Z6UMO {
	color: rgb(83, 18, 16) !important;
}

.SiteSettingsForm-textMediumBrown-LTkkj {
	color: rgb(142, 28, 10) !important;
}

.SiteSettingsForm-textSkyBlue-Vllc_ {
	color: rgb(37, 117, 141) !important;
}

.SiteSettingsForm-textGray-d_aam {
	color: rgb(77, 65, 51) !important;
}

.SiteSettingsForm-errorMessage-GNvtb {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.SiteSettingsForm-userText-oPoNd {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.SiteSettingsForm-panelHeader-FcUze {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.SiteSettingsForm-exportSection-YIuLo {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.SiteSettingsForm-exportSectionGridSub-dDJHl {
	grid-template-columns: 50% 49% !important;
}

.SiteSettingsForm-exportText-HHbo2 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.SiteSettingsForm-exportLinkImg-Qr25M {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.SiteSettingsForm-exportImg-lShfe {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SiteSettingsForm-linkBtn-j_qxH {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.SiteSettingsForm-table-X5qCN {
	display: table;
}

.SiteSettingsForm-tableRow-tjsXO {
	display: table-row;
}

.SiteSettingsForm-tableCell-rUFL_ {
	display: table-cell;
	float: none;
}

.SiteSettingsForm-formGroup-Q1uFw {
	margin-bottom: 6px;
}

.SiteSettingsForm-marginTop0-TS9nR {
	margin-top: 0;
}

.SiteSettingsForm-marginBottom20-hCMd0 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.SiteSettingsForm-bannerImageBg-YL9ft {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.SiteSettingsForm-bannerDelete-M8d3A {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.SiteSettingsForm-exportLink-O82Vt {
	padding-top: 10px;
	padding-right: 10px;
}

.SiteSettingsForm-seachContent-npWsM {
	padding-left: 0px;
	margin-bottom: 5px;
}

.SiteSettingsForm-marginBottom9-o3mnx {
	margin-bottom: 9px;
}

.SiteSettingsForm-spaceTop52-uH0c2 {
	margin-top: 52px;
}

.SiteSettingsForm-profileViewInner-NYLCD {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.SiteSettingsForm-profileViewMain-BaVp2 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.SiteSettingsForm-profileViewlabel-fbfFL {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.SiteSettingsForm-profileViewMainContent-Uv64C {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.SiteSettingsForm-reviewsFormStar-PZxCU {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.SiteSettingsForm-reviewsFormStar-PZxCU svg {
	cursor: pointer;
}

.SiteSettingsForm-addLanguageText-lxUQv {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.SiteSettingsForm-exportSection-YIuLo {
		grid-template-columns: 100%;
	}

	.SiteSettingsForm-spaceTop52-uH0c2 {
		margin-top: 18px;
	}

	.SiteSettingsForm-exportText-HHbo2 {
		float: none;
		margin-top: 12px;
	}

	.SiteSettingsForm-exportSectionGridSub-dDJHl {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.SiteSettingsForm-profileViewlabel-fbfFL {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SiteSettingsForm-profileViewMainContent-Uv64C {
		width: 100%;
		text-align: center;
	}

	.SiteSettingsForm-panelHeader-FcUze {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.SiteSettingsForm-faqImage-dbn9Q {
    width: 100%;
    max-width: 19px;
    vertical-align: middle;
    margin: 0 5px;
    position: relative;
    top: -1px;
}

.SiteSettingsForm-previewText-gCxEy {
    font-size: 14px;
    border-bottom: 1px solid var(--common-link-color);
}

.SiteSettingsForm-favIconText-HBFU5 {
    font-size: 14px;
    color: var(--inbox-dangerBtn-color);
    margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/SiteSettingsForm/SiteSettingsForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,WAAW;AACf","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.faqImage {\n    width: 100%;\n    max-width: 19px;\n    vertical-align: middle;\n    margin: 0 5px;\n    position: relative;\n    top: -1px;\n}\n\n.previewText {\n    font-size: 14px;\n    border-bottom: 1px solid var(--common-link-color);\n}\n\n.favIconText {\n    font-size: 14px;\n    color: var(--inbox-dangerBtn-color);\n    margin: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `SiteSettingsForm-space1-l7lrj`,
	"space2": `SiteSettingsForm-space2-SErba`,
	"space3": `SiteSettingsForm-space3-Sgngn`,
	"space4": `SiteSettingsForm-space4-SQxDK`,
	"space5": `SiteSettingsForm-space5-sPE26`,
	"space6": `SiteSettingsForm-space6-xJ6sy`,
	"space7": `SiteSettingsForm-space7-KlQLC`,
	"space8": `SiteSettingsForm-space8-HGq8Q`,
	"spaceTop1": `SiteSettingsForm-spaceTop1-kay2T`,
	"spaceTop2": `SiteSettingsForm-spaceTop2-MgvpP`,
	"spaceTop3": `SiteSettingsForm-spaceTop3-UI0tD`,
	"spaceTop4": `SiteSettingsForm-spaceTop4-qcaGS`,
	"spaceTop5": `SiteSettingsForm-spaceTop5-uoUhv`,
	"spaceTop6": `SiteSettingsForm-spaceTop6-hl3Oh`,
	"spaceTop7": `SiteSettingsForm-spaceTop7-CsADB`,
	"spaceTop8": `SiteSettingsForm-spaceTop8-qhvOG`,
	"noMargin": `SiteSettingsForm-noMargin-y4xL2`,
	"padding1": `SiteSettingsForm-padding1-tzQsr`,
	"padding2": `SiteSettingsForm-padding2-gcDKE`,
	"padding3": `SiteSettingsForm-padding3-Ryylr`,
	"padding4": `SiteSettingsForm-padding4-lUrgp`,
	"padding5": `SiteSettingsForm-padding5-ADyuB`,
	"padding6": `SiteSettingsForm-padding6-BYeX1`,
	"padding7": `SiteSettingsForm-padding7-MGU1S`,
	"paddingTop1": `SiteSettingsForm-paddingTop1-d6ZTm`,
	"paddingTop2": `SiteSettingsForm-paddingTop2-segOG`,
	"paddingTop3": `SiteSettingsForm-paddingTop3-JWQWW`,
	"paddingTop4": `SiteSettingsForm-paddingTop4-7CiJi`,
	"paddingTop5": `SiteSettingsForm-paddingTop5-vTf4v`,
	"paddingTop6": `SiteSettingsForm-paddingTop6-OI3ht`,
	"paddingTop7": `SiteSettingsForm-paddingTop7-PRqLt`,
	"noPadding": `SiteSettingsForm-noPadding-qZgFL`,
	"spaceMarginBottom0": `SiteSettingsForm-spaceMarginBottom0-Tot8w`,
	"textBold": `SiteSettingsForm-textBold-BWJGU`,
	"textBolder": `SiteSettingsForm-textBolder-wxMu7`,
	"textNormal": `SiteSettingsForm-textNormal-z8Pln`,
	"textDarkBlue": `SiteSettingsForm-textDarkBlue-HBfvP`,
	"textLightBlue": `SiteSettingsForm-textLightBlue-Io8vQ`,
	"textLightSandleGreen": `SiteSettingsForm-textLightSandleGreen-mnBh2`,
	"textLightBrown": `SiteSettingsForm-textLightBrown-PAZIk`,
	"textMediumMaroon": `SiteSettingsForm-textMediumMaroon-A6ImB`,
	"textBrown": `SiteSettingsForm-textBrown-Pmysh`,
	"textMaroon": `SiteSettingsForm-textMaroon-tbNOg`,
	"textDarkBrown": `SiteSettingsForm-textDarkBrown-Z6UMO`,
	"textMediumBrown": `SiteSettingsForm-textMediumBrown-LTkkj`,
	"textSkyBlue": `SiteSettingsForm-textSkyBlue-Vllc_`,
	"textGray": `SiteSettingsForm-textGray-d_aam`,
	"errorMessage": `SiteSettingsForm-errorMessage-GNvtb`,
	"userText": `SiteSettingsForm-userText-oPoNd`,
	"panelHeader": `SiteSettingsForm-panelHeader-FcUze`,
	"exportSection": `SiteSettingsForm-exportSection-YIuLo`,
	"exportSectionGridSub": `SiteSettingsForm-exportSectionGridSub-dDJHl`,
	"exportText": `SiteSettingsForm-exportText-HHbo2`,
	"exportLinkImg": `SiteSettingsForm-exportLinkImg-Qr25M`,
	"exportImg": `SiteSettingsForm-exportImg-lShfe`,
	"linkBtn": `SiteSettingsForm-linkBtn-j_qxH`,
	"table": `SiteSettingsForm-table-X5qCN`,
	"tableRow": `SiteSettingsForm-tableRow-tjsXO`,
	"tableCell": `SiteSettingsForm-tableCell-rUFL_`,
	"formGroup": `SiteSettingsForm-formGroup-Q1uFw`,
	"marginTop0": `SiteSettingsForm-marginTop0-TS9nR`,
	"marginBottom20": `SiteSettingsForm-marginBottom20-hCMd0`,
	"bannerImageBg": `SiteSettingsForm-bannerImageBg-YL9ft`,
	"bannerDelete": `SiteSettingsForm-bannerDelete-M8d3A`,
	"exportLink": `SiteSettingsForm-exportLink-O82Vt`,
	"seachContent": `SiteSettingsForm-seachContent-npWsM`,
	"marginBottom9": `SiteSettingsForm-marginBottom9-o3mnx`,
	"spaceTop52": `SiteSettingsForm-spaceTop52-uH0c2`,
	"profileViewInner": `SiteSettingsForm-profileViewInner-NYLCD`,
	"profileViewMain": `SiteSettingsForm-profileViewMain-BaVp2`,
	"profileViewlabel": `SiteSettingsForm-profileViewlabel-fbfFL`,
	"profileViewMainContent": `SiteSettingsForm-profileViewMainContent-Uv64C`,
	"reviewsFormStar": `SiteSettingsForm-reviewsFormStar-PZxCU`,
	"addLanguageText": `SiteSettingsForm-addLanguageText-lxUQv`,
	"faqImage": `SiteSettingsForm-faqImage-dbn9Q`,
	"previewText": `SiteSettingsForm-previewText-gCxEy`,
	"favIconText": `SiteSettingsForm-favIconText-HBFU5`
};
module.exports = ___CSS_LOADER_EXPORT___;
